// 회원가입·로그인을 마친 뒤 원래 보던 페이지로 돌아가기 위한 복귀 경로 관리
// (가입·SNS 로그인은 전체 페이지 이동이라 localStorage 에 잠깐 보관한다)

const RETURN_KEY = "authReturnPath";
const REOPEN_CHATBOT_KEY = "reopenChatbotAfterLogin";
const TTL_MS = 30 * 60 * 1000; // 30분 안에 마치지 않으면 버린다
const AUTH_PATHS = /^\/(login|signup|signup_sns|signup\/app|naverLoginCheck|appleLoginCheck|kakao|oauth)/i;

const read = (key) => {
  try {
    const saved = JSON.parse(localStorage.getItem(key) || "null");
    if (!saved || Date.now() - saved.at > TTL_MS) {
      localStorage.removeItem(key);
      return null;
    }
    return saved;
  } catch (e) {
    localStorage.removeItem(key);
    return null;
  }
};

// 같은 사이트 안의 경로로 정규화한다. 외부 주소·역슬래시·제어문자·가입/로그인 화면이면 null
const normalizePath = (path) => {
  if (typeof path !== "string" || !path.startsWith("/") || path.includes("\\")) return null;
  if ([...path].some((ch) => ch.charCodeAt(0) < 32)) return null; // 제어문자
  try {
    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    const normalized = url.pathname + url.search + url.hash;
    if (normalized.startsWith("//") || AUTH_PATHS.test(url.pathname)) return null;
    return normalized;
  } catch (e) {
    return null;
  }
};

export const saveReturnPath = (path) => {
  const safe = normalizePath(path);
  if (!safe) return;
  localStorage.setItem(RETURN_KEY, JSON.stringify({ path: safe, at: Date.now() }));
};

// 가입 완료처럼 이어서 로그인이 남은 경우: 경로를 지우지 않고 돌려준다
export const peekReturnPath = (fallback = "/") => {
  const saved = read(RETURN_KEY);
  return (saved && normalizePath(saved.path)) || fallback;
};

// 로그인 완료: 경로를 돌려주고 지운다
export const consumeReturnPath = (fallback = "/") => {
  const path = peekReturnPath(fallback);
  localStorage.removeItem(RETURN_KEY);
  return path;
};

export const currentPath = () => window.location.pathname + window.location.search;

// 챗봇에서 가입·로그인을 시작했으면, 로그인 뒤 돌아온 페이지에서 챗봇을 다시 연다
export const markReopenChatbot = () => localStorage.setItem(REOPEN_CHATBOT_KEY, JSON.stringify({ at: Date.now() }));

export const takeReopenChatbot = () => {
  if (!localStorage.getItem("authorization")) return false; // 아직 로그인 전이면 표시를 남겨 둔다
  const saved = read(REOPEN_CHATBOT_KEY);
  localStorage.removeItem(REOPEN_CHATBOT_KEY);
  return !!saved;
};
